import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M20.5 22h-1.9229c-.2763 0-.5-.2236-.5-.5s.2237-.5.5-.5H20.5a.501.501 0 00.5-.5v-16c0-.2759-.2246-.5-.5-.5h-2c-.2764 0-.5-.2236-.5-.5s.2236-.5.5-.5h2c.8271 0 1.5.6729 1.5 1.5v16c0 .8271-.6729 1.5-1.5 1.5zm-15.5767-.5c0-.2764-.2236-.5-.5-.5H2.5a.5007.5007 0 01-.5-.5v-16c0-.2759.2241-.5.5-.5h2c.2764 0 .5-.2236.5-.5S4.7764 3 4.5 3h-2C1.6729 3 1 3.6729 1 4.5v16c0 .8271.6729 1.5 1.5 1.5h1.9233c.2764 0 .5-.2236.5-.5zM15.5 12h-3V9c0-.275-.225-.5-.5-.5s-.5.225-.5.5v3h-3c-.275 0-.5.225-.5.5s.225.5.5.5h3v3c0 .275.225.5.5.5s.5-.225.5-.5v-3h3c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z',
  ],
  height: 24,
  width: 24,
});
